// removed by extract-text-webpack-plugin
module.exports = {"loading":"rio2016-3Lint rio2016-1aFvU","spinner":"rio2016-1ACbG rio2016-2_yYH"};


/*****************
 ** WEBPACK FOOTER
 ** ./styles/loading.css
 ** module id = 293
 ** module chunks = 0 1 2 3 4
 **/